module.exports = __webpack_public_path__ + "static/media/iv_analyst_view.67e8c08e.svg";